import { render, staticRenderFns } from "./IpSmallBurningTest.vue?vue&type=template&id=28b95aee&"
import script from "./IpSmallBurningTest.vue?vue&type=script&lang=js&"
export * from "./IpSmallBurningTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports